import React from "react";
import { useMsal } from "@azure/msal-react";
import { CircularProgress, Box } from "@mui/material";

export default function AuthGate({ children }) {
  const { inProgress } = useMsal();

  if (inProgress !== "none") {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
}
